<template>
    <div :class="tableClass">
        <div class="row row-border">
            <div
                v-for="(colHeader, colKey, colIndex) in columns"
                :key="colKey"
                :class="buildCellClass(colIndex) + ' col-header center-vertically'">
                {{ colHeader }}
            </div>
        </div>
        <div class="row row-border"
            v-for="(row, index) in rows"
            :key="index">
            <div
                v-for="(cellText, cellKey, cellIndex) in row"
                :key="cellKey"
                :class="buildCellClass(cellIndex) + ' center-vertically'">
                {{ cellText }}
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        columns: {
            type: Object,
            required: true
        },
        rows: {
            type: Array,
            required: true
        },
        tableClass: {
            type: String,
            required: false
        }
    },
    data() {
        return {}
    },
    methods: {
        buildCellClass(cellIndex) {
            return cellIndex == 0 ? 'col xs-3 sm-6 md-6 lg-6 xl-6 left center-vertically': 'col xs-3 sm-2 md-2 lg-2 xl-2 right center-vertically';
        }
    }
}
</script>

<style scoped>
    .right {
        text-align: right;
    }
    .left {
        text-align: left;
    }
    .col-header {
        color: #999;
    }

    .center-vertically {
        margin: auto 0;
    }

    .col {
        margin-left: -1px; /* fix styling for safari */
        padding-left: 0px;
        padding-right: 0px;
    }

    .padding-top {
        padding-top: 20px;
    }

    .padding-top-2 {
        padding-top: 50px;
    }

</style>
